import { motion, useTransform, useScroll, useAnimation } from "framer-motion";
import { useRef } from "react";
import {
  Model1,
  Model2,
  Model3,
  Model4,
  Model6,
  Model7,
} from "../../../core/assets";
import Fade from "react-reveal/Fade";




const cards = [
  {
    url: Model1,
    title: "Title 1",
    id: 1,
  },
  {
    url: Model6,
    title: "Title 2",
    id: 2,
  },
  {
    url: Model3,
    title: "Title 3",
    id: 3,
  },
  {
    url: Model4,
    title: "Title 4",
    id: 4,
  },
  {
    url: Model2,
    title: "Title 5",
    id: 5,
  },
  {
    url: Model6,
    title: "Title 6",
    id: 6,
  },
  {
    url: Model7,
    title: "Title 7",
    id: 7,
  },
];

interface CardProps {
  card: {
    url: string;
    title: string;
    id: number;
  };
}


export const HorizontalScrollCarousel = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const x = useTransform(scrollYProgress, [0, 1], ["1%", "-70%"]);

  const controls = useAnimation();
  const handleScrollComplete = async () => {
    // Animate the "heelo" section to scroll up
    await controls.start({ translateY: "200%" });
  };

  // const opacity = useTransform(
  //   scrollYProgress,
  //   [-1, -0.9, -0.1, 0],
  //   [0, 0, 1, 1]
  // );

  return (
    <>
      <section ref={targetRef} className="relative h-[110vh] ">
        <div className=" sticky top-0 flex h-screen py-5 items-center mt-0 md:mt-0 overflow-hidden bg-white  rounded-b-xl">
          <motion.div
            style={{ x }}
            className="flex md:gap-4 gap-1"
            onAnimationComplete={handleScrollComplete}
          >
            {cards.map((card) => {
              return (
              <Card card={card} key={card.id} />);
            })}
          </motion.div>
        </div>
      </section>
    </>
  );
};

const Card: React.FC<CardProps> = ({ card }) => {
  return (
    <div key={card.id} className="group md:h-[700px] md:w-[550px] h-[500px] w-[400px] overflow-hidden ">
      <Fade right>
        <img
          src={card.url}
          alt="img"
          className="rounded-xl w-[100%] md:w-[100%] object-contain h-[100%] md:object-cover transition-transform duration-300 group-hover:scale-110 hover:scale-110 "
        />
      </Fade>
    </div>
  );
};

export default HorizontalScrollCarousel;
